<!-- 评论-->
<template>
  <div class="comment-box-item" :class="{'last-comment-box-item':isLastElement}">
    <div class="comment-box-item-line"></div>
    <div class="comment-box-item-head">
      <div class="img-box">
        <img src="@/assets/images/icon-liuyan.png" />
      </div>
    </div>
    <div class="comment-box-item-main">
      <div class="title-time">
        <div class="title">
          <span
            @click="$parent.openProfile(approvalInfo.dingDingUserId)"
            class="author"
          >{{approvalInfo.employeeName}}</span>
          <span>添加了评论</span>
        </div>
        <div class="time">{{approvalInfo.approveDate}}</div>
      </div>
      <div v-if="approvalInfo.approveReason.length>0" class="content">
        “<span
          v-for="(contentItem,index) in approvalInfo.approveReason"
          :class="{'atName':contentItem.id.length>0}"
          :key="index"
          @click="$parent.openProfile(contentItem.id)"
          v-html="contentItem.layer"
        ></span>”
      </div>
      <filebox
        :fileInfo="{filesrcs: approvalInfo.attachmentPath, filenames: approvalInfo.attachmentName}"
      ></filebox>
    </div>
  </div>
</template>
<script>
import filebox from "@/components/Share/Preview/fileBox";
export default {
  components: {
    filebox
  },
  props: {
    isLastElement: false,
    approvalInfo: {
      type: Object,
      default() {
        return {};
      }
    }
  }
};
</script>
<style lang="less" scoped>
.last-comment-box-item {
  padding-bottom: 0.4rem !important;
  .comment-box-item-line {
    width: 0 !important;
  }
}
.comment-box-item {
  width: 100%;
  display: flex;
  position: relative;
  padding-bottom: 1rem;
  .comment-box-item-line {
    position: absolute;
    left: 0.6667rem;
    height: 100%;
    width: 0.0267rem;
    background: #ffe2a9;
    z-index: 7;
  }
  .comment-box-item-head {
    z-index: 8;
    width: 1.3333rem;
    height: 1.3333rem;
    display: flex;
    justify-content: center;
    .img-box {
      width: 0.586667rem;
      height: 0.586667rem;
      img {
        width: 100%;
        height: 100%;
        border-radius: 50%;
      }
    }
  }
  .comment-box-item-main {
    flex: 1;
    margin-left: 0.2667rem;
    .title-time {
      display: flex;
      .time {
        font-size: 0.2933rem;
        color: #999999;
      }
      .title {
        flex: 1;
        font-size: 0.4533rem;
        color: #2c2c2c;
        font-weight: normal;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        .author {
          color: #fdc139;
        }
      }
    }
    .content {
      margin-top: 0.2667rem;
      font-size: 0.4rem;
      color: #666666;
      .atName {
        color: #fdc139;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Approval/ApprovalProcess/approvalComment.vue